import axios from "axios";
const jsonConfig = require("../../config.json");

const getAllAiDecitionReasons = async () => {
  try {
    const getAllResponse = await axios.get(jsonConfig.apiUrl + "getallaidecisionreasons", {
      headers: {
        "x-functions-key": jsonConfig.key,
      },
    });

    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getAllAiDecitionReasons;
